"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconUser = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconUser = function IconUser(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.001 11.999c3.374 0 6.111-2.686 6.111-5.998C18.112 2.686 15.375 0 12 0 8.626 0 5.889 2.686 5.889 6c0 3.313 2.737 6 6.111 6l.001-.001zM.5 17.644C2.858 21.454 7.127 24 12.001 24c4.873 0 9.142-2.546 11.499-6.356a.587.587 0 00-.128-.297c-1.508-1.85-3.893-2.948-7.092-2.948H7.722c-3.201 0-5.586 1.099-7.093 2.948a.587.587 0 00-.129.296v.001z",
    fillRule: "evenodd"
  }));
};
exports.IconUser = IconUser;